export const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_job-cert-tracker/artifacts/k4rfk2v8_Logo%20no%20Ltd%20on%20end.webp";
export const LOGO_DARK_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_job-cert-tracker/artifacts/yc1f60gz_logo%20black%20background.webp";
export const APP_NAME = "Self Certify UK";
